<template>
  <NuxtLayout>
    <NuxtPage class="font-poppins" />
  </NuxtLayout>
</template>
<script setup>
import { useRoute } from "#app";

useHead({
  htmlAttrs: {
    lang: "en-US",
  },
  link: [
    { rel: "dns-prefetch", href: "//ik.imagekit.io" },
    { rel: "dns-prefetch", href: "//fonts.googleapis.com" },
    // { rel: 'dns-prefetch', href: '//api.hireheroes.com' },
    // { rel: 'dns-prefetch', href: '//hireheroes-backend-v2.onrender.com' },
    // { rel: 'preconnect', href: '//hireheroes-backend-v2.onrender.com', crossorigin: 'anonymous' },
    { rel: "preconnect", href: "//ik.imagekit.io", crossorigin: "anonymous" },
    {
      rel: "preconnect",
      href: "//api.hireheroes.com",
      crossorigin: "anonymous",
    },
    {
      rel: "stylesheet",
      href: "//fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800;&display=swap",
    },
  ],
});

// const config = useRuntimeConfig();
const user = useUserStore();
const walletStore = useWalletStore();
const route = useRoute(); // Get the current route

// Access the `accessMode` query parameter
const accessMode = route.query.accessMode;
if (accessMode == "preview") {
  user.setPreviewMode(true);
}

console.log("Access Mode:", accessMode);

const appOpened = ref(false);

// Function to attempt to open app
const tryOpenApp = () => {
  const deepLink = "hireheroes://google-auth";
  const androidIntentLink = "intent://google-auth#Intent;scheme=hireheroes;end";
  const start = Date.now();
  const isAndroid =
    typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);

  // Android Chrome handles intent:// more reliably than custom schemes on auto-redirects.
  window.location.href = isAndroid ? androidIntentLink : deepLink;

  // Fallback if app not installed
  setTimeout(() => {
    const end = Date.now();
    if (end - start < 1600) {
      console.log("App not installed, staying on web");
      alert("App not installed, staying on web");
      appOpened.value = false;
      // Optionally show a message or button
    } else {
      appOpened.value = true;
    }
  }, 1500);
};

onBeforeUnmount(() => {
  console.log("unmounting", walletStore.intervalId);
});

onMounted(() => {
  console.log("App OnMounted");
  const googleAuthStatus = route.query.googleAuth;
  const isGoogleAuthFlag = (value) =>
    value === "true" ||
    value === "false" ||
    value === true ||
    value === false;
  const shouldTryOpenApp = Array.isArray(googleAuthStatus)
    ? googleAuthStatus.some(isGoogleAuthFlag)
    : isGoogleAuthFlag(googleAuthStatus);
  // Only run on mobile web browsers
  if (
    typeof window !== "undefined" &&
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) &&
    shouldTryOpenApp
  ) {
    tryOpenApp();
  }
});
</script>
